import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerMultipleSocialAccountsCount.graphql';
import { Query, QueryinfluencerMultipleSocialAccountsCountArgs } from '../../__generated__/globalTypes';

export const useInfluencerMultipleSocialAccountsCountQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerMultipleSocialAccountsCountArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerMultipleSocialAccountsCountArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerMultipleSocialAccountsCountLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerMultipleSocialAccountsCountArgs>
): QueryResult<Query, QueryinfluencerMultipleSocialAccountsCountArgs> & {
  getInfluencerMultipleSocialAccountsCount: LazyQueryExecFunction<
    Query,
    QueryinfluencerMultipleSocialAccountsCountArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerMultipleSocialAccountsCount, result] = useLazyQuery<
    Query,
    QueryinfluencerMultipleSocialAccountsCountArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerMultipleSocialAccountsCount, ...result };
};

export const useInfluencerMultipleSocialAccountsCountPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerMultipleSocialAccountsCount = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerMultipleSocialAccountsCountArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerMultipleSocialAccountsCountArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerMultipleSocialAccountsCount };
};
// Suspense Query Hooks
export const useInfluencerMultipleSocialAccountsCountSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerMultipleSocialAccountsCountArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerMultipleSocialAccountsCountArgs>(QUERY, {
    ...options
  });

  return result;
};
